import { render, staticRenderFns } from "./barmian.vue?vue&type=template&id=3438ff38&scoped=true&"
import script from "./barmian.vue?vue&type=script&lang=js&"
export * from "./barmian.vue?vue&type=script&lang=js&"
import style0 from "./barmian.vue?vue&type=style&index=0&id=3438ff38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3438ff38",
  null
  
)

export default component.exports